import { matchPath } from 'react-router';
import { AvailableIcon } from 'src/components/atoms/Icon';
import { IS_DEV } from 'src/constants';

export enum AppServices {
  MM = 'mm',
  DA = 'da',
  MO = 'mo',
  LT = 'lt',
  SOS = 'sos',
}

export type MMMRoute = {
  url: string;
  name: string;
  subroutes?: MMMRoute[];
  icon: AvailableIcon;
  service?: AppServices;
};

const routes: Array<MMMRoute> = [
  {
    url: '/mmm',
    name: 'Marketing Mix Modelling',
    icon: 'mmm-updated',
    service: AppServices.MM,
    subroutes: [
      {
        url: '/mmm/overview',
        name: 'Overview',
        icon: 'overview',
      },
      {
        url: '/mmm/summary',
        name: 'Summary',
        icon: 'mmm-performance',
      },
      {
        url: '/mmm/trends',
        name: 'Trends',
        icon: 'mmm-cost-per-unit',
      },
      {
        url: '/mmm/modelling',
        name: 'Modelling',
        icon: 'mmm-modelling',
      },
    ],
  },
  {
    url: '/digital',
    name: 'Digital',
    icon: 'digital-insights',
    service: AppServices.DA,
    subroutes: [
      {
        url: '/digital/overview',
        name: 'Overview',
        icon: 'overview',
      },
      {
        url: '/digital/explorer',
        name: 'Campaign Explorer',
        icon: 'da-explorer',
      },
      {
        url: '/digital/deep-dive',
        name: 'Campaign Groups',
        icon: 'da-deep-dive',
      },
      {
        url: '/digital/channels',
        name: 'Channels',
        icon: 'da-channels',
      },
      {
        url: '/digital/search',
        name: 'Search',
        icon: 'da-search',
      },
    ],
  },
  {
    url: '/marketing-optimization',
    name: 'Marketing Optimization',
    icon: 'marketing-optimization',
    service: AppServices.MO,
  },
  {
    url: '/longterm-effect',
    name: 'Long Term Effects',
    icon: 'long-term-effect',
    service: AppServices.LT,
  },
  {
    url: '/inbox',
    name: 'Inbox',
    icon: 'inbox',
  },
  {
    url: '/goals-and-targets',
    name: 'Goals&Targets',
    icon: 'goals-and-targets',
  },
];

export function getAllRoutes(): MMMRoute[] {
  return Object.values(routes);
}

export function getActiveRoute(pathname: string): MMMRoute | null {
  for (const route of routes) {
    if (matchPath(`${route.url}/*`, pathname)) {
      return route;
    }
  }

  return null;
}
